export const Card = ({ number, icon, title, text, background, minHeight }) => {
  return (
    <>
      <div
        style={{
          boxShadow: '0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A',
          background: background,
          minHeight: minHeight,
        }}
        className="max-w-[300px] flex flex-col items-center justify-around p-[10px] h-full rounded-lg"
      >
        <div className="flex flex-col items-center gap-[10px]">
          {icon && <img width="90px" height="90px" src={icon} alt="" />}
          {number && (
            <div className="bg-[#2F72BD] rounded-full text-white w-[48px] h-[48px] mb-[20px] flex justify-around items-center">
              {number}
            </div>
          )}
          <h3 className="text-[22px] text-center ">{title}</h3>
        </div>
        <p
          className="text-center text-[18px]"
          dangerouslySetInnerHTML={{ __html: text }}
        ></p>
      </div>
    </>
  );
};
